import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

// styles
import { WrapPage } from './index.styles'

// data
import dataRoutes from '../../../../data/dataRoutes'

// constant
import { env, envServer, DEV_SV, PROD_SV } from '../../../../constant/environmentTypes'
import * as path from '../../../../constant/path'

const Page = (props) => {
    return (
        <WrapPage {...props}>
            <Switch>
                {
                    dataRoutes.map(({ Component, envValid, ...props}) => (
                        envValid.includes(env) 
                        ? (
                            <Route {...props} key={props.path}>
                                <Component />
                            </Route>
                        )
                        : null
                    ))
                }
                {/* {

                    // envServer === PROD_SV ?
                    // <Redirect to={`/${path.MAIN}/${path.DEVICE}`} />
                    // : */}
                    <Redirect to={`/${path.MAIN}/${path.TRANSACTION}`} />
                {/* } */}
                
            </Switch>
        </WrapPage>
    )
}

export default Page
